export default "__VITE_ASSET__DGnA6td8__"